import React, { useState, useEffect } from 'react'

import { postArticleinfolist } from '../../../store/requests/apiRequests/postArticleinfolist'
import { useAppSelector } from '../../../hooks'

import * as Styled from './styles'

const CompleteArticlesTable: React.FC = () => {
  const { bom } = useAppSelector((state) => state.configResult)
  const { isStoreLoggedIn, content } = useAppSelector((state) => state.init)
  const { apiConfigs } = useAppSelector((state) => state.requests)

  if (!isStoreLoggedIn) {
    throw new Error(
      `Internal component CompleteArticlesTable should not be used for external user, isStoreLoggedIn: ${isStoreLoggedIn})`
    )
  }

  const [articleInfoList, setArticleInfoList] = useState<any[]>([])

  useEffect(() => {
    if (bom) {
      postArticleinfolist({
        apiConfigs,
        data: bom.flatMap((section) =>
          section.articles.map((article) => ({ Sku: article.erpItemNumber, Quantity: article.quantity }))
        ),
        onSuccess: (response: { data: any[] }) => {
          const articleInfoList = response.data
          setArticleInfoList(articleInfoList)
        },
      })
    }
  }, [bom])

  return articleInfoList.length ? (
    <Styled.CompleteArticlesTable>
      <thead>
        <tr>
          <th>Qty</th>
          <th>Art. no.</th>
          <th>Article</th>
          <th>Del.w.*</th>
        </tr>
      </thead>
      <tbody>
        {articleInfoList.map(({ Sku, Title, TitleLong, ArticleUrl, Quantity, Deliveryweek }, index) => (
          // Use index as key since Sku is not guaranteed to be unique due to mallisar
          <tr key={index}>
            <td>{Quantity}</td>
            <td>{Sku}</td>
            <td>
              <a href={ArticleUrl} target="_blank" rel="noopener noreferrer">
                {Title || TitleLong ? `${Title} ${TitleLong}` : <em>({content?.other?.articleTitleIsMissing})</em>}
              </a>
            </td>
            <td>{Deliveryweek}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={4}>
            <em>
              * Deliveryweek, i.e. when article is available in SKBV or dropshipping supplier stock for shipment to
              customer
            </em>
          </td>
        </tr>
      </tfoot>
    </Styled.CompleteArticlesTable>
  ) : null
}

export default CompleteArticlesTable
